import { Heading } from "@freightsimple/ui-core/Typography/Heading";
import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

interface DeliveryAddressPageProp {
  shipment: Shipment;
}

export function ModifyShipmentDeliveryAddressPage(
  _props: DeliveryAddressPageProp,
) {
  return <Heading level={1}>Delivery Address</Heading>;
}
